module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox, $) {
	'use strict';

	fox.registerWidget('VrPlayer', {
		configure: function () {
			
			/* !!! IMPORTANT !!! */
			/* FALLBACK_URL will work if there is a parameter (dl8-start-from-cors-fallback=true) */
			/* The player adds this option now */

			this.FALLBACK_URL = 'http://ec-large.centrofiles.com/h3/CoH9Id9aghI3BoqpwR7hX4pnbaO-Ot-IJN4lZgme-zutMxsDIyn7cd1svpNI6hTr4CYAnocH2jelY0-Mt3ZW35Ix3JE0Pir5/vrplayer.html';
			this.SUPPORT_CROSSORIGIN = true;
			this.registerOptions('', {
				/* Player Options */
				vrPlayerLoaded: false,
				//LICENSEKEY: '4e3b16dad1d80ce0b663ae27911acfb3a7a8f2d0' /* free license key */,
				//LICENSEKEY: '2e68b0611e00422a1671c172c0e02efdb5adaab8', /* free license key */,
				LICENSEKEY: 'd56e7d4505e6950eac9b8bea589db2be04de18c8' /* badoink license key */,
				path: '//cdn.delight-vr.com/latest/dl8-',
				playerLogoUrl: false,
				playerPrimaryColor: '#ffffff',
				playerSecondaryColor: '#000000',

				/* Widget Options */
				container: '.player-wrapper',
				template: 'vrVideo',
				mode: 'format',
				jsonizeMapRequest: true,
				manualRender: true,
				widgets: {
					mapApi:{
						widget: 'Api',
						method: 'site.format.getMap'
					},
					getCdnFormatLinkApi:{
						widget: 'Api',
						method: 'site.format.get'
					}
				},
				handleWom: {
					recieveContentId: {
						widget: '@parent',
						event: 'setContentId',
						callback: 'recieveContentId'
					},
					added: {
						widget: '@this',
						event: 'addedToDom',
						callback: 'scrollToWrapper'
					},
				}
			});

			this.callParent('configure', arguments);
		},

		init: function() {
			this._included = false;

			this.include();
			
			this.callParent('init', arguments);
		},

		activate: function() {
			this.resetData();
			this.callParent('activate', arguments);
		},

		deactivate: function() {
			this.resetData();
			this.callParent('deactivate', arguments);
		},

		include: function() {
			if (this._included) {
				return;
			}
			
			this.addPlayerLogo();

			this.createMetaTag('dl8-customization-no-content-badge');
			this.createMetaTag('dl8-customization-no-brand-watermark-logo');
			this.createMetaTag('dl8-customization-primary-color', this.getOption('playerPrimaryColor'));
			this.createMetaTag('dl8-customization-secondary-color', this.getOption('playerSecondaryColor'));

			this.addVrScript();

			this._included = true;
		},

		addPlayerLogo: function() {
			var logo = this.getOption('playerLogoUrl');
			if (logo) {
				this.createMetaTag('dl8-customization-brand-logo', logo);
			} else {
				this.createMetaTag('dl8-customization-no-brand-logo');
			}
		},

		createMetaTag: function(name, content) {
			var meta = window.document.createElement('meta');

			meta.name = name;

			if (content) {
				meta.content = content;
			}

			window.document.head.appendChild(meta);
		},

		addVrScript: function() {
			var script = window.document.createElement('script');

			script.onload = fox.bind(this.vrPlayerLoaded, this);
			script.src = this.getOption('path') + this.getOption('LICENSEKEY') + '.js';
				
			window.document.body.appendChild(script);
		},

		vrPlayerLoaded: function() {
			this.vrPlayerLoaded = true;
			this.dispatchEvent('vrPlayerLoaded');
		},

		resetData: function() {
			this.vrType = 'STEREO_180_LR';
			this.setContentId('');
			this.setPoster('');
			this.setFormatMap([]);
			this.setBitrates([]);
		},

		recieveContentId: function(id) {
			this.formatGetMap(id);
		},

		formatGetMap: function(id, resCallback, callbackParams) {
			var 
				api = this.wom1('#mapApi'),
				apiParams = {};
			
			this.checkSupportCrossOrigin();

			this.setContentId(id);

			this.waitEvent(api, 'success', resCallback || 'formatGetMapApiSuccessHandler', callbackParams || {});

			apiParams = {
				contentId: this.getContentId(),
				mode: this.getOption('mode')
			};

			if (!this.SUPPORT_CROSSORIGIN) {
				apiParams.get = 'link';
			}

			api.send(apiParams, this.getOption('jsonizeMapRequest'));
		},

		getCdnFormatLinkApi: function(format, resCallback) {
			var 
				api = this.wom1('#getCdnFormatLinkApi'),
				apiParams = {};


			apiParams = {
				params: this.getContentId() + '/' + format + '/stream',
				video: 1,
				get: 'link'
			};

			api.psend(apiParams).then(function(response){
				var res = response.params.answer.response;
				if (resCallback) {
					resCallback(res);
				}
			});
		},

		formatGetMapApiSuccessHandler: function(data) {
			this.preparePlayerData(data.answer.response);
		},

		preparePlayerData: function (map) {
			this.setFormatMap(map);
			this.buildBitrates();
			this.setPoster(this.getPrimaryThumb());

			var bitrates = this.getBitrates();

			this.setTemplateOptions({
				poster: this.getPoster(),
				sources: bitrates,
				vrType: this.vrType
			});



			if (this.SUPPORT_CROSSORIGIN) {
				this.renderPlayer();
			} else {
				this.getCdnFormatLinkApi(this.startFormat, function(response) {
					var cdnLinks = [];
					for(var i = 0; i < bitrates.length; i++) {
						if (bitrates[i].name === this.startFormat) {
							bitrates[i].src = response;
							cdnLinks.push(bitrates[i]);
						}
					}

					this.setTemplateOptions('sources', cdnLinks);
					this.renderPlayer();
					
				}.bind(this));
			}
		},

		renderPlayer: function () {
			this.setFallbackUrl();

			if (this.vrPlayerLoaded) {
				this.render();
			} else {
				this.waitEvent('@this', 'vrPlayerLoaded', fox.bind(function () {
					this.render();
				}));
			}
		},

		setFallbackUrl: function() {
			var data = this.getTemplateOptions(),
				url = this.FALLBACK_URL;

			data.LICENSEKEY = this.getOption('LICENSEKEY');
			data.playerPrimaryColor = this.getOption('playerPrimaryColor');
			data.playerSecondaryColor = this.getOption('playerSecondaryColor');
			data.playerLogoUrl = this.getOption('playerLogoUrl');
			data.brandName = fox.site.getEnv('site.title');
			data.brandUrl = fox.site.getEnv('curUrl');
				
			url += '?start=' + window.btoa(JSON.stringify(data));

			this.setTemplateOptions('fallbackUrl', url);
		},

		buildBitrates: function() {
			var bitrates = [];
			var startFormatHeight =0;
			fox.each(this.getFormatMap().view, function(val, name) {

				//if (name !== 'hd960_vr_mobile' && name !== 'sd960_vr_mobile') {
				//	return;
				//}

				if (val.roles && !fox.inArray(val.roles, this.mode)) {
					return; // means 'continue'
				}
				
				var clip = window.location.protocol + '//' + this.window.location.host + val.link,
					params = ['video=1'];

				if (fox.site.member && fox.cookie.get('user_auth')) {
						params.push('auth_hash=' + fox.cookie.get('user_auth'));
				} else {
					params.push('auth_hash=empty');
				}

				if(fox.getEnv('siteProps.settingId')){
					params.push('settingId=' + fox.getEnv('siteProps.settingId'));
				}

				clip += (clip.indexOf('?') === -1 ? '?' : '&') + params.join('&');
				
				var bitrate = {
					name: name,
					type: 'video/' + val.type,
					src: clip
				};

				if (startFormatHeight < val.height) {
					this.startFormat = name;
				}

				if (val.vrType) {
					this.vrType = val.vrType;
				}
				
				bitrates.push(bitrate);

			}, this);

			if (bitrates.length) {
				bitrates.sort(function (a, b) {
					var aH = parseInt(a.height),
						bH = parseInt(b.height);
					if (aH > bH) {
						return -1;
					}
					if (aH < bH) {
						return 1;
					}
					return 0;
				});
			}
			this.setBitrates(bitrates);
			return this;
		},

		getPrimaryThumb: function(size) {
			/* Needs refactoring */

			var hSize = size,
				formats = this.getFormatMap(),
				alias,
				format;

			if (!hSize) {
				format = formats.view[this.startFormat];
				if (format) {
					hSize = format.height;
				} else {
					hSize = 480;
				}
			}

			if (hSize > 1080) {
				alias = 'h1360i';
			} else if (hSize > 720) {
				alias = 'h720i'; /* becouse h1080i doesn't exist */
			} else if (hSize > 480) {
				alias = 'h720i';
			} else {
				alias = 'h480i';
			}
			return 'http://cdn-small.nl.storage.adultcentro.com/' + this.getContentId() + '/thumb/primary/'+ alias;
		},

		setContentId: function(id) {
			this._contentId = id;
		},

		getContentId: function(value) {
			return this._contentId;
		},

		setFormatMap: function(map) {
			this.dispatchEvent('_changeFormat', {contentId: this.contentId});
			this._formatMap = map;
			return this;
		},

		getFormatMap: function() {
			return this._formatMap;
		},

		setBitrates: function(value) {
			this._bitrates = value;
		},

		getBitrates: function() {
			return this._bitrates;
		},

		setPoster: function(url) {
			this._poster = url;
		},

		getPoster: function() {
			return this._poster;
		},

		scrollToWrapper: function() {
			var pos = $(this.getOption('container')).parent().offset().top;
			$('html, body').animate({
				scrollTop: pos
			}, 300);
		},

		checkSupportCrossOrigin: function() {
			if (typeof window.safari === 'object' || /iPad|iPhone|iPod/.test(navigator.platform) || /(MSIE|Trident\/|Edge\/)/i.test(navigator.userAgent)) {
				this.SUPPORT_CROSSORIGIN = false;
			}
		}

	}, 'Widget');
})(fox, fox.jQuery);

 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/widget/vrplayer.js
// module id = 922
// module chunks = 4